var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sales-report__vendors" },
    _vm._l(_vm.vendors, function(vendor) {
      return _c("Vendor", { key: vendor.id, attrs: { vendor: vendor } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }